import autoTable from "jspdf-autotable";
import { isTulFonItem, makeTailorItem, tailorWindowFabricRequirements, sheetNumber } from "./tulFonSheetModel";
import { drawTailorBlock, measureTailorBlocks } from "./tailorSheetDrawing";

const dateLabel = value => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString("tr-TR");
};

export function renderTailorSheet(doc, order, logoUrl) {
  const items = (order.items || []).filter(isTulFonItem).map(makeTailorItem);
  if (!items.length) throw new Error("Bu kayıtta Tül/Fon perde kalemi bulunmuyor.");
  const reference = String(order.orderNo || order.quoteNo || order.id || "Taslak");
  const isQuote = !order.orderNo;
  doc.setProperties({ title: `Terzi Föyü — ${reference}`, subject: "Tül / Fon fiyatsız üretim föyü", author: "ZEN ERP" });
  const header = () => {
    if (logoUrl) {
      const image = doc.getImageProperties(logoUrl);
      const width = Math.min(25, 10 * image.width / image.height);
      doc.addImage(logoUrl, "PNG", 12, 10, width, width * image.height / image.width);
    }
    doc.setFont("NotoSans", "bold"); doc.setTextColor(30, 41, 59); doc.setFontSize(15);
    doc.text("TERZİ FÖYÜ", 43, 16);
    doc.setFontSize(7.5); doc.text("TÜL / FON · FİYATSIZ ATÖLYE BELGESİ", 43, 21);
    doc.setFontSize(8);
    doc.text(`${isQuote ? "TEKLİF" : "SİPARİŞ"} #${reference}`, 198, 13, { align: "right", maxWidth: 65 });
    doc.setFont("NotoSans", "normal"); doc.setFontSize(7);
    doc.text(isQuote ? "TASLAK — ÜRETİM ONAYI DEĞİLDİR" : "ÜRETİM DETAYLARI", 198, 22, { align: "right" });
    doc.setDrawColor(229, 50, 42); doc.setLineWidth(0.6); doc.line(12, 25, 198, 25);
    autoTable(doc, {
      startY: 28, margin: { left: 12, right: 12 }, theme: "plain",
      styles: { font: "NotoSans", fontSize: 8, cellPadding: 1.2, textColor: [30, 41, 59], overflow: "linebreak" },
      columnStyles: { 0: { cellWidth: 120 }, 1: { cellWidth: 66 } },
      body: [[`Müşteri: ${order.customerName || "Belirtilmedi"}`, `Tarih: ${dateLabel(order.createdAt)}`],
        [`Proje: ${order.projectName || "—"}`, `Termin: ${dateLabel(order.deadline || order.deliveryDate)}`]],
    });
    return doc.lastAutoTable.finalY + 5;
  };
  let y = header();
  const page = () => { doc.addPage(); y = header(); };
  const blocks = items.flatMap(item => measureTailorBlocks(doc, item));
  for (let i = 0; i < blocks.length; i += 2) {
    const row = blocks.slice(i, i + 2);
    const height = Math.max(...row.map(block => block.height));
    if (y + height > 275) page();
    row.forEach((block, column) => drawTailorBlock(doc, block, 12 + column * 97, y));
    y += height + 6;
  }
  if (y + 35 > 275) page();
  doc.setFont("NotoSans", "bold"); doc.setFontSize(10); doc.setTextColor(30, 41, 59);
  doc.text("KUMAŞ HAZIRLIK LİSTESİ · PENCERE BAZINDA", 12, y + 4);
  y += 7;
  for (const window of tailorWindowFabricRequirements(items)) {
    const startPage = doc.getNumberOfPages();
    const metraj = value => value === null ? "Ölçü eksik" : `${sheetNumber(value)} mtül`;
    autoTable(doc, {
      startY: y, margin: { left: 12, right: 12, top: 46, bottom: 24 },
      pageBreak: "avoid", rowPageBreak: "avoid",
      head: [[{ content: `${String(window.number).padStart(2, "0")} · ${window.room} · ${window.type} · Adet: ${sheetNumber(window.qty)}`,
        colSpan: 5, styles: { fillColor: [232, 238, 243], textColor: [30, 41, 59], fontStyle: "bold" } }],
      ["Malzeme", "Kumaş / Kod / Renk", "Kumaş eni", "Pencere başına", "Toplam metraj"]],
      body: window.materials.map(row => [row.kind, [row.fabric, row.code, row.color].filter(Boolean).join(" · "),
        `${sheetNumber(row.fabricWidth)} cm`, metraj(row.perWindowMtul), metraj(row.totalMtul)]),
      styles: { font: "NotoSans", fontSize: 8, cellPadding: 2, overflow: "linebreak", lineColor: [210, 215, 222], lineWidth: 0.15 },
      headStyles: { fillColor: [30, 41, 59], fontStyle: "bold" },
      columnStyles: { 0: { cellWidth: 23 }, 1: { cellWidth: 78 }, 2: { cellWidth: 23 }, 3: { cellWidth: 31 }, 4: { cellWidth: 31 } },
      willDrawPage: () => { if (doc.internal.getCurrentPageInfo().pageNumber > startPage) header(); },
    });
    y = doc.lastAutoTable.finalY + 4;
  }
  const notes = [
    "Ölçüler net bitmiş ölçüdür; çizimler şematiktir. Metraj, sipariş hesabıdır; kesin kesim planı değildir.",
    "Standart metrajda dikiş/kanca/katlama payı eklenmez. Boy 300 cm üzerindeyse her boyda 30 cm pay hesaba dahildir.",
    ...(items.some(item => item.raw.astarli) ? ["Astar hazırlık metrajı siparişte ana kumaşla aynı hesaplanır; astarın gerçek eni ve kesim payı atölyede teyit edilmelidir."] : []),
    ...(order.productionNotes ? [`Üretim notu: ${order.productionNotes}`] : []),
  ];
  doc.setFont("NotoSans", "normal"); doc.setFontSize(7.5);
  for (const note of notes) {
    const lines = doc.splitTextToSize(note, 182);
    for (const line of lines) {
      if (y + 4 > 274) page();
      doc.setFont("NotoSans", "normal"); doc.setFontSize(7.5); doc.setTextColor(60);
      doc.text(line, 12, y + 3); y += 4;
    }
    y += 1;
  }
  if (y + 12 > 274) page();
  doc.setDrawColor(90); doc.setLineWidth(0.2);
  [[12, "Kesim"], [58, "Dikiş"], [104, "Ölçü kontrolü"], [151, "Paket / Teslim"]].forEach(([x, label]) => {
    doc.rect(x, y + 5, 3, 3); doc.text(label, x + 5, y + 7.6);
  });
  const count = doc.getNumberOfPages();
  for (let index = 1; index <= count; index++) {
    doc.setPage(index); doc.setDrawColor(190); doc.line(12, 281, 198, 281);
    doc.setFont("NotoSans", "normal"); doc.setFontSize(7); doc.setTextColor(85);
    doc.text(`ZEN · Terzi Föyü · #${reference}`, 12, 286);
    doc.text(`${index} / ${count}`, 198, 286, { align: "right" });
  }
  return doc;
}